import request from '@/utils/request'

export function getInvitationLink(data = {}) {
  return request({
    url: '/user/invitation/link',
    method: 'post',
    data,
  })
}
